/**
 * useProjectRoles — los roles que se pueden asignar en un proyecto
 * (OT-0058): los de la metodología de su ciclo, más los que piden sus
 * flujos de aprobación, más los que ya tienen sus miembros. Lo calcula el
 * backend (`GET /projects/{id}/roles`) contra el snapshot del proyecto.
 *
 * Lo comparten Equipo & RACI (para asignarlos) y la vista General (para
 * mostrar sus nombres), con la misma caché.
 */

import { useQuery } from '@tanstack/react-query'

import { fetchProjectRoles } from '../api/projects'
import { useAccessToken } from '../auth/useAccessToken'

export function useProjectRoles(projectId: string) {
  const { accessToken } = useAccessToken()
  return useQuery({
    queryKey: ['projects', projectId, 'roles'],
    queryFn: () => {
      if (!accessToken) throw new Error('no_access_token')
      return fetchProjectRoles(accessToken, projectId)
    },
    enabled: !!accessToken,
    staleTime: 60_000,
    retry: false,
  })
}
